module.exports = __webpack_public_path__ + "img/help.09977bb7.png";